<!--<button mat-icon-button class="close-button" [mat-dialog-close]="true">-->
<!--    <mat-icon class="close-icon" color="warn">close</mat-icon>-->
<!--</button>-->
<mat-dialog-content class="mat-typography">
    <h3>Aquí tenés que elegir la actividad actual y principal de tu empresa que consigna el Certificado Pyme, sin
        importar lo que vayas a financiar con este crédito) </h3>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Entendido</button>
</mat-dialog-actions>
